import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import CurrencyFormats from 'commons-vehicle/constants/currencyFormats.js';

import 'commons-vehicle/Vehicle/components/Payment/CashPayment/CashPayment.scss';

const CashPayment = ({ children, isUsed, msrp }) => {
    return (
        <div className="cash-section tile-payment-info">
            <div className="payment-row price-row">
                <p className="payment-row-title sr-text is-bold">
                    {LocaleService.t(isUsed ? 'VEHICLE_TILE.USED_PDSF' : 'VEHICLE_TILE.PDSF')}
                </p>
                <div className="payment-row-section">
                    <p className="payment-row-price sr-text is-bold">
                        {LocaleService.l(msrp, CurrencyFormats.CURRENCY_0)}
                    </p>
                </div>
            </div>
            {children}
        </div>
    );
};

CashPayment.defaultProps = {
    isUsed: false,
};

CashPayment.propTypes = {
    children: PropTypes.element.isRequired,
    isUsed: PropTypes.bool,
    msrp: PropTypes.number.isRequired,
};

CashPayment.displayName = 'CashPayment';

export default CashPayment;



// WEBPACK FOOTER //
// ./src/Vehicle/components/Payment/CashPayment/CashPayment.jsx